import React from 'react';
import Icon from '@material-ui/core/Icon';

// ASSETS
import { ReactComponent as MyBundleIconSvg } from '@/assets/images/mb-icon.svg';

function MBIcon(props) {
  return <Icon {...props} component={MyBundleIconSvg} />;
}

export default React.memo(MBIcon);
